(() => {
  const setBlockState = (block, active, requiredSelectors = []) => {
    if (!block) return;
    block.hidden = !active;

    block.querySelectorAll('input, select, textarea').forEach((field) => {
      field.disabled = !active;
      field.required = active && requiredSelectors.some((selector) => field.matches(selector));

      if (!active) {
        if (field.tagName === 'SELECT') {
          field.selectedIndex = 0;
        } else {
          field.value = '';
        }
      }
    });
  };

  const initGiftForm = (root) => {
    if (!root || root.dataset.gkInitialized === 'true') return;
    root.dataset.gkInitialized = 'true';

    const wrap = root.querySelector('[data-gk-wrap]');
    const noshiPosition = root.querySelector('[data-gk-noshi-position]');
    const noshiDetails = root.querySelector('[data-gk-noshi-details]');
    const noshiTitle = root.querySelector('[data-gk-noshi-title]');
    const noshiOther = root.querySelector('[data-gk-noshi-other]');
    const nameType = root.querySelector('[data-gk-name-type]');
    const nameInput = root.querySelector('[data-gk-name-input]');
    const condolence = root.querySelector('[data-gk-condolence]');
    const condolenceText = root.querySelector('[data-gk-condolence-text]');

    const updateNoshi = () => {
      const wrappingEnabled = wrap?.value !== '包装なし';
      if (!wrappingEnabled && noshiPosition) {
        noshiPosition.value = 'のしなし';
      }

      const noshiEnabled = wrappingEnabled && noshiPosition?.value !== 'のしなし';
      setBlockState(noshiDetails, noshiEnabled, [
        '[data-gk-noshi-title]',
      ]);

      if (noshiEnabled) {
        updateNoshiOther();
        updateNameInput();
      }
    };

    const updateNoshiOther = () => {
      const active = !noshiTitle?.disabled && noshiTitle?.value === 'その他';
      setBlockState(noshiOther, active, ['input']);
    };

    const updateNameInput = () => {
      const active = !nameType?.disabled && nameType?.value !== '名入れなし';
      setBlockState(nameInput, active, ['input']);
    };

    const updateCondolence = () => {
      const active = condolence?.value === '自由文';
      setBlockState(condolenceText, active, ['textarea']);
    };

    wrap?.addEventListener('change', updateNoshi);
    noshiPosition?.addEventListener('change', updateNoshi);
    noshiTitle?.addEventListener('change', updateNoshiOther);
    nameType?.addEventListener('change', updateNameInput);
    condolence?.addEventListener('change', updateCondolence);

    updateNoshi();
    updateCondolence();
  };

  const initAll = (scope = document) => {
    scope.querySelectorAll('[data-gk-gift-options]').forEach(initGiftForm);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll());
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
})();
